{
  "intro": "Публичные ключи, которые можно положить на новые серверы, чтобы входить по своему закрытому ключу, а не по паролю. Ключи хранятся в этом проекте Hetzner; добавление бесплатно.",
  "add": "Добавить SSH-ключ",
  "addLead": "Вставьте публичный ключ (файл .pub) или загрузите его из файла. Закрытый ключ не покидает ваш компьютер.",
  "publicKey": "Публичный ключ",
  "publicKeyHint": "Одна строка, начинается с ssh-ed25519, ssh-rsa или ecdsa-sha2-…. Ключа ещё нет? Выполните: ssh-keygen -t ed25519",
  "publicKeyWhy": "Сервер хранит публичный ключ; войти может тот, у кого есть парный закрытый. Публичным ключом делиться безопасно.",
  "privateKey": "Это закрытый ключ. Никуда его не вставляйте: нужен файл .pub рядом с ним.",
  "invalid": "Hetzner не принимает этот ключ. Проверьте, что строка скопирована целиком.",
  "duplicate": "Такой ключ или такое название уже есть в проекте.",
  "fromFile": "Загрузить из файла",
  "name": "Название",
  "nameHint": "Чтобы потом узнать ключ, например по устройству, на котором он лежит.",
  "submit": "Добавить ключ",
  "added": "SSH-ключ «{{name}}» добавлен",
  "empty": "SSH-ключей пока нет",
  "emptyLead": "Добавьте свой публичный ключ один раз и выбирайте его при создании сервера: вход без пароля, и подобрать его невозможно.",
  "fingerprint": "Отпечаток",
  "fingerprintHint": "Короткая контрольная сумма ключа; сравните её с ssh-keygen -lf -E md5 <файл>.pub, чтобы убедиться, что ключ ваш.",
  "type": "Тип",
  "created": "Добавлен",
  "copy": "Скопировать публичный ключ",
  "copied": "Публичный ключ скопирован",
  "rename": "Переименовать",
  "delete": "Удалить",
  "deleteTitle": "Удалить SSH-ключ «{{name}}»?",
  "deleteNew": "Новые серверы с этим ключом создать будет нельзя.",
  "deleteExisting": "На серверах, где он уже есть, ключ останется: если доступ нужно закрыть, удалите его из ~/.ssh/authorized_keys сами.",
  "deleted": "SSH-ключ «{{name}}» удалён"
}
